import {
  Component,
  AfterViewInit,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { NonAdminRoutes, ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, NgIf } from '@angular/common';
//declare var $: any;

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule, NgIf],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: RouteInfo[] = [];
  path = '';

  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  handleNotify() {
    this.notify.emit(!this.showClass);
  }
  // this is for the open close
  addExpandClass(element: string) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  // End open close
  ngOnInit() {
    let loggedInuserRole = JSON.parse(sessionStorage.getItem("currentUser")!);
     let Role = loggedInuserRole.role;
     if(Role === 'Admin')
     {
        
        this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
        this.sidebarnavItems = ROUTES;
       
     }
     else if(Role ==='Standard User')
     {
        this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
        this.sidebarnavItems = NonAdminRoutes;
     }
     else if(Role ==='Internal User')
     {
        this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
        this.sidebarnavItems = NonAdminRoutes;
     }
  }
}
